import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { loadProgressBar } from 'axios-progress-bar';
import App from './application';
import * as serviceWorker from './serviceWorker';
import 'typeface-roboto';
import 'axios-progress-bar/dist/nprogress.css';
import { axiosInstance } from './axios-instance';

loadProgressBar({ easing: 'ease', speed: 600, showSpinner: false }, axiosInstance);

ReactDOM.render(<App />, document.querySelector('#root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
